<template>
  <main class="content">
    <!-- content -->
    <section class="for">
      <div class='container'>
        <div class="for__wrapper">
          <h1 class="for__title">Для кого</h1>
          <div class="for__list list-for">
            <div class="list-for__top">
              <div class="list-for__number">1</div>
              <div class="list-for__title">Вам грозит лишение прав?</div>
            </div>
            <div class="list-for__text">
              Если Вы уже «попались» и грозит лишение прав, суд уже назначен или его дата неизвестна – переходите в «Расписание», выбирайте дату ближайшего обучения по Вашей ситуации и сохраните свой водительское удостоверение
            </div>
          </div>
          <div class="for__list list-for">
            <div class="list-for__top">
              <div class="list-for__number">2</div>
              <div class="list-for__title">Вам грозит лишение прав?</div>
            </div>
            <div class="list-for__text">
              Если Вы уже «попались» и грозит лишение прав, суд уже назначен или его дата неизвестна – переходите в «Расписание», выбирайте дату ближайшего обучения по Вашей ситуации и сохраните свой водительское удостоверение
            </div>
          </div>
          <div class="for__list list-for">
            <div class="list-for__top">
              <div class="list-for__number">3</div>
              <div class="list-for__title">Вам грозит лишение прав?</div>
            </div>
            <div class="list-for__text">
              Если Вы уже «попались» и грозит лишение прав, суд уже назначен или его дата неизвестна – переходите в «Расписание», выбирайте дату ближайшего обучения по Вашей ситуации и сохраните свой водительское удостоверение
            </div>
          </div>
          <div class="for__list list-for">
            <div class="list-for__top">
              <div class="list-for__number">4</div>
              <div class="list-for__title">Вам грозит лишение прав?</div>
            </div>
            <div class="list-for__text">
              Если Вы уже «попались» и грозит лишение прав, суд уже назначен или его дата неизвестна – переходите в «Расписание», выбирайте дату ближайшего обучения по Вашей ситуации и сохраните свой водительское удостоверение
            </div>
          </div>
          <div class="for__list list-for">
            <div class="list-for__top">
              <div class="list-for__number">5</div>
              <div class="list-for__title">Вам грозит лишение прав?</div>
            </div>
            <div class="list-for__text">
              Если Вы уже «попались» и грозит лишение прав, суд уже назначен или его дата неизвестна – переходите в «Расписание», выбирайте дату ближайшего обучения по Вашей ситуации и сохраните свой водительское удостоверение
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
// import axios from '@/router/http'
export default {
  name: 'article',
  data () {
    return {
      article: {}
    }
  },
  components: {
    VRuntimeTemplate
  },
  methods: {
    initPage () {
    },
    showModal (id, text) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
    }
  },
  mounted () {
    this.initPage()
  },
  watch: {
    $route (to, from) {
      this.initPage()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/who.vue